import { render } from "./ResetPaswword.vue?vue&type=template&id=056f47b1"
import script from "./ResetPaswword.vue?vue&type=script&lang=js"
export * from "./ResetPaswword.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__